import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeFilters } from 'actions/search';
import { Link } from 'react-router-dom';
import { getHighlightedText } from '../utils';

import s from '../style';

@connect(null, { changeFilters })
export default class Streets extends Component {
  onItemClick = () => {
    this.props.closeModal();
  }

  render() {
    const {
      name,
      items,
      isShown,
      changeFilters,
      highlight
    } = this.props;

    if (isShown && items.length) {
      return (
        <div className={s.resultSection}>
          <div className={s.resultSectionTitle}>{name}</div>
          {items.map(item => (
            <Link
              key={item.id}
              className={s.resultItem}
              to={`/building/${item.id}`}
              onClick={this.onItemClick}
            >
              <div className={s.resultItemTitle}>
                <div className={s.resultItemTitle}>{getHighlightedText(item.address, highlight)}</div>
                <div className={s.resultItemDescrip}>{item.name}</div>
              </div>
            </Link>
            ))}
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/Streets/Streets.js